// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12UWG","field":"styles_field__JhBKE","fieldCol":"styles_fieldCol__22qdc","diffCol":"styles_diffCol__1rbmD","diff":"styles_diff__3E_4Q"};